import { usePreferences } from '../context/PreferencesContext';

export const useCurrencyFormatter = () => {
  const { currency, currencySymbols } = usePreferences();

  const formatCurrencyWithPreference = (amount: number, overrideCurrency?: string) => {
    const selectedCurrency = (overrideCurrency || currency) as keyof typeof currencySymbols;
    const symbol = currencySymbols[selectedCurrency] || '₹';
    
    return `${symbol}${amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  return {
    formatCurrency: formatCurrencyWithPreference,
    currency,
    currencySymbol: currencySymbols[currency as keyof typeof currencySymbols],
  };
};
